// removed by extract-text-webpack-plugin
module.exports = {"ScreenSMMin":"(min-width: 768px)","youGetOffer":"G767ffc","youGetOfferTitle":"G917341","rafGel":"Gdcb696","rafGelContent":"G426097","youGetLabel":"Gdee254"};